import type {
  NotificationTypeKey,
  NotificationTypeSettings,
} from 'settings/components/NotificationCards';

export default function findChangedNotificationType(
  previous: NotificationTypeSettings,
  next: NotificationTypeSettings
): NotificationTypeKey | undefined {
  return (Object.keys(next) as NotificationTypeKey[]).find(
    (key) =>
      next[key].enabled !== previous[key].enabled ||
      next[key].channel !== previous[key].channel
  );
}
